import { Component, EventEmitter, HostListener, Input, Output } from '@angular/core';
import { KeycloakEventType, KeycloakService } from 'keycloak-angular';
import { LocalStorageService } from '../../services/storage.service';
import { BusinessContextService } from '../../services/business-context.service';

@Component({
  selector: 'app-nav-header',
  standalone: true,
  imports: [],
  templateUrl: './nav-header.component.html',
  styleUrl: './nav-header.component.css'
})
export class NavHeaderComponent {
  @Input() isOpen: boolean = false; // controlled by parent
  elementValue: any;
  sidebarStyle: string = '';
  localData: any = '';
  userName: string = '';
  initials: string = '';
  businessName: string = '';

  @Output() sidebarToggle = new EventEmitter<{ toggleVal: boolean }>(); // event emitter
  @Output() emailOpne = new EventEmitter<{ emailval: boolean }>(); // event emitter
  constructor(
    private keycloak: KeycloakService,
    private ls: LocalStorageService,
    private bizCtx: BusinessContextService,
  ) {}

  ngOnInit() {
    this.localData = localStorage.getItem('data-sidebar-style');
    // if (this.localData != null) {
    //   document.body.setAttribute('data-sidebar-style', this.localData);
    // }
    // Try to load user and subscribe to auth events
    this.loadUser().catch(() => {});
    try {
      (this.keycloak as any)?.keycloakEvents$?.subscribe(async (event: any) => {
        const type = event?.type as KeycloakEventType;
        if (
          type === KeycloakEventType.AuthSuccess ||
          type === KeycloakEventType.AuthRefreshSuccess ||
          type === KeycloakEventType.TokenExpired
        ) {
          await this.loadUser();
        }
      });
    } catch {}

    // Cargar nombre de negocio desde el contexto/localStorage
    try {
      const name = this.bizCtx.getSelectedName();
      const uuid = this.bizCtx.getSelected();
      this.businessName = name || uuid || '';
    } catch {
      this.businessName = '';
    }
  }

  toggleSidebar() {   // Request parent to toggle sidebar
    this.sidebarToggle.emit({ toggleVal: !this.isOpen });
  }

  @HostListener('window:resize', ['$event'])

  
  onResize(event: any) {
    this.localData = localStorage.getItem('data-sidebar-style');
    this.elementValue = document.body.getAttribute('data-sidebar-style');
    let desiredOpen = false;
    if (event.target.innerWidth < 1200 && event.target.innerWidth > 766) {
      desiredOpen = true; // mini
      this.sidebarStyle = 'mini';
    } else if (event.target.innerWidth <= 766) {
      desiredOpen = false;
      this.sidebarStyle = 'overlay';
    } else {
      desiredOpen = false;
      this.sidebarStyle = this.localData ? this.localData : 'full';
    }
    this.sidebarToggle.emit({ toggleVal: desiredOpen });
    document.body.setAttribute('data-sidebar-style', this.sidebarStyle);
  }

  async logout() {
    try {
      // Limpia todo el localStorage y el contexto de negocio antes de salir
      try {
        this.ls.clear();
        this.bizCtx.setSelected(null);
      } catch {}
      await this.keycloak.logout(window.location.origin);
    } catch (e) {
      console.error('[NavHeader] Logout error', e);
    }
  }

  private async loadUser() {
    try {
      const logged = await this.keycloak.isLoggedIn();
      const parsed: any = (this.keycloak as any)?.getKeycloakInstance?.()?.tokenParsed || {};
      if (!logged && !parsed) { this.userName = ''; this.initials = ''; return; }
      if (logged) {
        try {
          const profile = await this.keycloak.loadUserProfile();
          const full = [profile?.firstName, profile?.lastName].filter(Boolean).join(' ').trim();
          this.userName = full || profile?.username || profile?.email || '';
        } catch {
          // fallback below
        }
      }
      if (!this.userName) {
        const fullToken = [parsed?.given_name, parsed?.family_name].filter(Boolean).join(' ').trim();
        this.userName = fullToken || parsed?.name || parsed?.preferred_username || parsed?.email || '';
      }
      this.initials = this.computeInitials(this.userName || '');
    } catch {
      this.userName = '';
      this.initials = '';
    }
  }

  private computeInitials(name: string): string {
    try {
      const s = (name || '').toString().trim();
      if (!s) return '';
      const parts = s.split(/\s+/).filter(Boolean);
      if (parts.length === 1) {
        const p = parts[0];
        // if email/username, take first two alphanumerics
        const letters = (p.replace(/[^A-Za-z0-9]/g, '').toUpperCase()).slice(0, 2);
        return letters || p.slice(0, 2).toUpperCase();
      }
      const first = parts[0][0];
      const last = parts[parts.length - 1][0];
      return (first + last).toUpperCase();
    } catch {
      return '';
    }
  }

}
